const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case "TRAINING_DOCS_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "TRAINING_DOCS_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "TRAINING_DOCS_SUCCESS":
			return {
				...state,
				documents: action.data,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/trainingDocs.js